import React, { createContext, useState, useEffect } from 'react';
import { GetTheme } from '../../services/authServices';
import { getDomainName } from '../../Util/helper_functions';
import { THEME_VARAIBLE_MAP, STORAGE_KEYS } from '../../Util/key_helper';
export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const domain_name = getDomainName();
    const [themeColors, setThemeColors] = useState({});

    // Apply CSS variables globally
    const applyTheme = (colors) => {
        Object.entries(colors).forEach(([field, value]) => {
            const cssVar = THEME_VARAIBLE_MAP[field];
            if (cssVar && value) {
                document.documentElement.style.setProperty(cssVar, value);
            }
        });
    };
    // Function for save theme to local stoarge
    const saveThemeToLocal = (colors) => {
        try {
            localStorage.setItem(STORAGE_KEYS.THEME_COLORS, JSON.stringify(colors));
        } catch (err) {
            console.error("Error saving theme to localStorage:", err);
        }
    };

    // Function for load theme from local storage 
    const loadThemeFromLocal = () => {
        try {
            const storedTheme = localStorage.getItem(STORAGE_KEYS.THEME_COLORS);
            if (storedTheme) {
                const parsedTheme = JSON.parse(storedTheme);
                setThemeColors(parsedTheme);
                applyTheme(parsedTheme);
                return parsedTheme;
            }
        } catch (err) {
            console.error("Error loading theme from localStorage:", err);
        }
        return null;
    };
    // Function for get theme a[o call]
    const GetThemeApiCall = async () => {
        try {
            const res = await GetTheme({ domain: domain_name });
            if (res.status && res.data) {
                setThemeColors(res.data);
                applyTheme(res.data);
                saveThemeToLocal(res.data);
            } else {
                console.log("Error getting theme:")
            }
        } catch (err) {
            console.error("Error loading theme:", err);
        }
    };

    // On mount
    useEffect(() => {
        // Apply local theme first (for instant color)
        loadThemeFromLocal();

        // Then fetch  theme and update
        GetThemeApiCall();
    }, []);

    const saveTheme = (newColors) => {
        setThemeColors(newColors);
        saveThemeToLocal(newColors);
        applyTheme(newColors);

    };
    // Reset preview (cancel or after update)
    const resetTheme = () => {
        setThemeColors(themeColors);
        applyTheme(themeColors);

    };
    return (
        <ThemeContext.Provider value={{ themeColors, resetTheme, saveTheme, applyTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
